module.exports = __webpack_public_path__ + "static/media/story-4.bc859925.jpg";